import './popup-content.scss';


    document.addEventListener('DOMContentLoaded', function() {
        // Function to show the popup
        function showPopup(popupId) {
            var popup = document.getElementById(popupId);
            if (popup) {
                popup.style.display = 'block';
            }
        }

        // Function to hide the popup
        function hidePopup(popup) {
            popup.style.display = 'none';
        }

        console.log('Valid Popup IDs:', validPopupIds);


        // Handle clicks on anchor links
        document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
            anchor.addEventListener('click', function(event) {
                var href = this.getAttribute('href');
                if (href && href.startsWith('#')) {
                    var popupId = href.substring(1); // Get the popup ID from the href attribute
                    if (validPopupIds.includes(popupId)) {
                        event.preventDefault(); // Prevent default behavior only for valid popup links
                        showPopup(popupId);
                    }
                }
            });
        });

        // Handle popup close button clicks
        document.querySelectorAll('.popup-close').forEach(function(closeButton) {
            closeButton.addEventListener('click', function() {
                var popup = this.closest('.basic-popup');
                hidePopup(popup);
            });
        });

        // Handle overlay clicks to close the popup
        document.querySelectorAll('.popup-overlay').forEach(function(overlay) {
            overlay.addEventListener('click', function() {
                var popup = this.closest('.basic-popup');
                hidePopup(popup);
            });
        });
    });

